export default import.meta.ROLLUP_FILE_URL_gIeCcW9w;